import { takeEvery, takeLatest } from 'redux-saga/effects';
import * as types from '../constants';
import { loadAPIVersion } from './version';
import {
  exportListToCSV,
  exportListToSplunk,
  exportListToSTIX,
  exportListToSTIXLimited,
  exportListToJSON,
  clearScoreDetails,
  loadScoreDetails,
  loadNewScoreDetails,
  toggleFalsePositive,
  toggleTruePositive,
  updateIocList,
  updateIocListFromCache,
  paginationIocList,
  paginationIocListFromCache,
  loadDnsRecords,
  loadARecordsDomainEnrichment,
  loadAAAARecordsDomainEnrichment,
  loadCNAMERecordsDomainEnrichment,
  loadMXRecordsDomainEnrichment,
  loadNSRecordsDomainEnrichment,
  loadSOARecordsDomainEnrichment,
  loadTXTRecordsDomainEnrichment,
  loadIpDensity,
  loadPTRLookup,
  loadMergeAPIEnrichment,
  loadMergeAPINewEnrichment,
  loadUtilsParseIOC,
  loadMergeAPIDomainDetails,
  loadMergeAPIIPDetails,
  loadMergeAPIExploreDetails,
  loadNameServerAutoFill,
  loadASNAutoFill,
  loadMergeAPIMergeDetails,
  loadMergeAPIDomainInfraTags,
  loadMergeAPIExploreAnyIPDetails,
  loadMergeAPIDensityDetails,
  loadMergeAPIExploreIPDensityDetails,
  loadMergeAPIWhoisDetails,
  loadMergeAPIWhoisFallbackDetails,
  createIOC,
  deleteIOC,
  deleteIOCFromCollection,
  clearExploreDetails,
  exportSingleIOC,
  exportExploreResultToCSV,
  exportExploreResultToJSON,
  exportSpoofingToCSV,
  exportSpoofingToJSON,
  exportDanglingDNSToCSV,
  exportDanglingDNSToJSON,
  exportHostingInfrasctructureASNsToCSV,
  exportHostingInfrasctructureASNsToJSON,
  exportShadowITtoCSV,
  exportShadowITtoJSON,
  exportSubdomainFinderToCSV,
  exportSubdomainFinderToJSON,
  loadMergeAPIExploreRecipe,
  loadMergeAPIExploreRecipes,
  loadAttackSurfaceMapping,
  loadDigitalThreatManagement,
  saveMergeAPIExploreRecipeForwardA,
  deleteMergeAPIExploreRecipeForwardA,
  updateMergeAPIExploreRecipeForwardA,
  loadMergeAPIExploreRecipeForwardA,
  changeScopeMergeAPIExploreRecipeForwardA,
  saveMergeAPIExploreRecipeNameServerChanges,
  deleteMergeAPIExploreRecipeNameServerChanges,
  updateMergeAPIExploreRecipeNameServerChanges,
  loadMergeAPIExploreRecipeNameServerChanges,
  changeScopeMergeAPIExploreRecipeNameServerChanges,
  saveMergeAPIExploreRecipeTXT,
  deleteMergeAPIExploreRecipeTXT,
  updateMergeAPIExploreRecipeTXT,
  loadMergeAPIExploreRecipeTXT,
  changeScopeMergeAPIExploreRecipeTXT,
  saveMergeAPIExploreRecipeReverseA,
  loadMergeAPIExploreRecipeReverseA,
  deleteMergeAPIExploreRecipeReverseA,
  updateMergeAPIExploreRecipeReverseA,
  changeScopeMergeAPIExploreRecipeReverseA,
  saveMergeAPIExploreRecipeDomainsOnServer,
  deleteMergeAPIExploreRecipeDomainsOnServer,
  updateMergeAPIExploreRecipeDomainsOnServer,
  loadMergeAPIExploreRecipeDomainsOnServer,
  changeScopeMergeAPIExploreRecipeDomainsOnServer,
  saveMergeAPIExploreRecipeSpoofing,
  deleteMergeAPIExploreRecipeSpoofing,
  updateMergeAPIExploreRecipeSpoofing,
  loadMergeAPIExploreRecipeSpoofing,
  changeScopeMergeAPIExploreRecipeSpoofing,
  saveMergeAPIExploreRecipeIPDiversity,
  deleteMergeAPIExploreRecipeIPDiversity,
  updateMergeAPIExploreRecipeIPDiversity,
  loadMergeAPIExploreRecipeIPDiversity,
  changeScopeMergeAPIExploreRecipeIPDiversity,
  loadMergeAPIExploreRecipeLatestDNSRecords,
  saveMergeAPIExploreRecipeLatestDNSRecords,
  updateMergeAPIExploreRecipeLatestDNSRecords,
  changeScopeMergeAPIExploreRecipeLatestDNSRecords,
  deleteMergeAPIExploreRecipeLatestDNSRecords,
  loadHostingInfrastructureASNData,
  saveMergeAPIExploreRecipeHostingInfrastructureASNs,
  deleteMergeAPIExploreRecipeHostingInfrastructureASNs,
  updateMergeAPIExploreRecipeHostingInfrastructureASNs,
  loadMergeAPIExploreRecipeHostingInfrastructureASNs,
  changeScopeMergeAPIExploreRecipeHostingInfrastructureASNs,
  loadDanglingDNSRecordsCountData,
  saveMergeAPIExploreRecipeDanglingDNSRecordsCount,
  deleteMergeAPIExploreRecipeDanglingDNSRecordsCount,
  updateMergeAPIExploreRecipeDanglingDNSRecordsCount,
  loadMergeAPIExploreRecipeDanglingDNSRecordsCount,
  changeScopeMergeAPIExploreRecipeDanglingDNSRecordsCount,
  loadDanglingDNSProtectionData,
  saveMergeAPIExploreRecipeDanglingDNSProtection,
  deleteMergeAPIExploreRecipeDanglingDNSProtection,
  updateMergeAPIExploreRecipeDanglingDNSProtection,
  loadMergeAPIExploreRecipeDanglingDNSProtection,
  changeScopeMergeAPIExploreRecipeDanglingDNSProtection,
  saveMergeAPIExploreRecipeSubdomainFinder,
  deleteMergeAPIExploreRecipeSubdomainFinder,
  updateMergeAPIExploreRecipeSubdomainFinder,
  loadMergeAPIExploreRecipeSubdomainFinder,
  changeScopeMergeAPIExploreRecipeSubdomainFinder,
  saveMergeAPIExploreRecipeShadowIT,
  deleteMergeAPIExploreRecipeShadowIT,
  updateMergeAPIExploreRecipeShadowIT,
  loadMergeAPIExploreRecipeShadowIT,
  changeScopeMergeAPIExploreRecipeShadowIT,
  loadIOCSFromSpecificCollection,
  loadIOCSPageFromSpecificCollection,
  loadIOCSFromSpecificSharedCollection,
  loadMergeAPIRiskScores,
  loadMergeAPIASNDetails,
  loadHistoryQueries,
  updateHistoryQuery,
  addNewHistoryQuery,
  loadHistoryQueryResult,
  copyHistoryQueryResult,
  clearCopyHistoryQueryResult,
  downloadHistoryQueryResult,
  saveMonitoringQuery,
  loadMonitoringQueries,
  deleteMonitoringQuery,
  changeScopeMonitoringQuery,
  runMonitoringQuery,
  loadMonitoringQueryResultsHistory,
  updateMonitoringQuery,
  loadMonitoringFile,
  loadMonitoringJSONFile,
  loadMergeAPIExploreQueryBuilderSchemas,
  loadMergeAPIExploreQueryBuilderSchema,
  saveMergeAPIExploreQueryBuilderSchema,
  deleteMergeAPIExploreQueryBuilderSchema,
  changeScopeMergeAPIExploreQueryBuilderSchema,
  loadIOCNotes,
  deleteIOCNote,
  createIOCNote,
  updateIOCNote,
  postMergeAPIExploreDetails,
  postMergeAPIMergeDetails,
  deleteMergeAPIExploreRecipeHostingInfraIPs,
  saveMergeAPIExploreRecipeHostingInfraIPs,
  updateMergeAPIExploreRecipeHostingInfraIPs,
  loadMergeAPIExploreRecipeHostingInfraIPs,
  changeScopeMergeAPIExploreRecipeHostingInfraIPs,
  saveBreadCrumbs,
  saveMergeAPIExploreRecipeNameInTXT,
  deleteMergeAPIExploreRecipeNameInTXT,
  updateMergeAPIExploreRecipeNameInTXT,
  loadMergeAPIExploreRecipeNameInTXT,
  changeScopeMergeAPIExploreRecipeNameInTXT,
  queryNameInTXTRecipe,
  cloneRecipe,
  loadBrandImpersonationRecipeResults,
  loadHostingInfrastructureASNsRecipeResults,
  loadDanglingDNSDetectionRecipeResults,
  loadHostingInfrastructureIPsRecipeResults,
  loadShadowITRecipeResults,
  loadSubdomainFinderRecipeResults,
} from './ioc';
import {
  login,
  impersonate,
  resetPassword,
  confirmPasswordReset,
  enable2fa,
  loginWith2fa,
  load2faQR,
  remove2fa,
  checkToken,
  refreshAccessToken,
  register,
  validateEmailOnRegister,
} from './auth';
import {
  loadAmberReports,
  loadAmberReport,
  loadAmberReportCount,
  filterAmberReports,
  loadAmberReportFeeds,
  loadAmberReportTags,
  setAmberReportsAsSeen,
  setAmberReportUnseen,
  checkEnrichmentFeedHasBlogs,
} from './blog';

// Subscription
import { confirmExtendSubscription } from './subscription';

import {
  loadUserPreferences,
  updateUserPreferences,
  inviteUser,
  loadUser,
  updateUserProfile,
  updateOrganization,
  uploadPhoto,
  loadUsers,
  loadUsersInfo,
  createUser,
  deleteUser,
  updateUser,
  changePassword,
  setCustomIPRangeIndicator,
  setCustomGeoIP,
  loadCustomGeoIP,
  loadCustomGeoIPOrganisation,
  loadCustomDomainIndicators,
  setCustomDomainIndicators,
  deleteCustomDomainIndicators,
  loadCustomIPRangeIndicators,
  setCustomIPRangeIndicators,
  updateCustomIPRangeIndicators,
  deleteCustomIPRangeIndicators,
  loadMySubscriptionPlan,
  loadMySubscriptionLimit,
  loadOrganization,
  setWebsocketConnection,
  setWebsocketConnectionStatus,
  // updateIPIndicatorsOrganization,
} from './user';
import {
  loadFilters,
  loadFilterProfiles,
  saveFilterProfile,
  saveFilterProfileLocally,
  applyFilters,
  updateFilterProfile,
  changeFilterProfileName,
  deleteFilterProfile,
  loadSpecificFilter,
  loadTagOptions,
  autoCompleteTagOptions,
} from './filters';
import {
  consumeFeedData,
  consumeFileData,
  verifyAuth,
  createFeed,
  deleteFeed,
  deleteMyFeed,
  deleteOrganizationFeed,
  deleteCollection,
  loadFeeds,
  loadNewFeeds,
  loadCollections,
  loadOrganizationCollections,
  loadOrganizationFeeds,
  loadNewOrganizationFeeds,
  loadMyCollections,
  loadMyFeeds,
  loadNewMyFeeds,
  loadCollection,
  activateCollection,
  activateFeed,
  activateMyFeed,
  activateOrganizationFeed,
  saveEmptyCollection,
  updateFeed,
  updateCollection,
  changeScopeCollection,
  publishCollection,
  shareCollection,
  loadGlobalFeeds,
  createGlobalFeed,
  deleteGlobalFeed,
  updateGlobalFeed,
  loadAvailableFeeds,
  loadIPEditableFeeds,
  loadDomainEditableFeeds,
  loadURLEditableFeeds,
  createVirtualFeed,
  updateVirtualFeed,
  uploadToCollection,
  exportFeed,
  createCollectionByFileUpload,
  createCollectionByURLUpload,
  loadAllFeeds,
  loadFeedPerformance,
  clearSourcesReports,
  loadSourcesReports,
  loadSourceReport,
  loadFeedsGlobal,
  loadNewFeedsGlobal,
} from './feed';
import {
  getDeepScanMetadata,
  getDeepScan,
  getRecentlyRanSPQLQueries,
  getSavedSPQLQueries,
  createSPQLQuery,
  updateSPQLQuery,
  deleteSPQLQuery,
  getQueryExamples,
} from './deep_scan';
import {
  loadSources,
  loadSource,
  loadSourcesIocCountsAndIsActive,
  loadSourcesIocCounts,
  createEmptySource,
  createURLSource,
  createFileSource,
  deleteSource,
  changeSourceScope,
  activateSource,
  updateSource,
  updateFileSource,
  addIOCJson,
  publishSource,
} from './source';
import {
  loadIntegrations,
  updateIntegrations,
  saveIntegrations,
  deleteIntegrations,
  loadSlack,
  saveSlack,
  updateSlack,
  deleteSlack,
  loadMTeams,
  saveMTeams,
  updateMTeams,
  deleteMTeams,
  getAccessTokenBrowserling,
} from './integrations';
import { searchForTags, addIOCTag, removeIOCTag, deleteTag } from './tags';
import { createGroup, deleteGroup, loadGroups, updateGroup } from './groups';
import { loadPermissions, requestPermission } from './permissions';
import {
  createDepartment,
  deleteDepartment,
  loadDepartments,
  updateDepartment,
} from './departments';
import {
  createAPIAccess,
  deleteAPIAccess,
  loadAPIAccess,
  updateAPIAccess,
} from './APIAccess';
import {
  createDashboard,
  deleteDashboard,
  loadDashboards,
  loadDashboardDetails,
  loadWidgets,
  updateDashboard,
  updateDashboardCell,
} from './dashboards';
import {
  loadMostWidespreadTag,
  loadTopTrendingTags,
  loadFPAvg,
} from './widgets';
import {
  loadPlaybooks,
  loadPlaybooksLogs,
  updatePlaybooks,
  savePlaybooks,
  deletePlaybooks,
  runPlaybooks,
} from './playbooks';
import {
  loadCustomerOrganizationsList,
  createCustomerOrganization,
  updateCustomerOrganization,
  loadCustomerSubscriptionPlan,
  createCustomerSubscription,
  updateCustomerSubscription,
  restrictSubscriptionCustomerOrganization,
  unrestrictSubscriptionCustomerOrganization,
  notifySubscriptionRestrictedCustomerOrganization,
  loadCustomerOrganization,
  deleteCustomerOrganization,
  loadCustomerOrganizationUsersList,
  loadCustomerOrganizationUsersListPage,
  createCustomerOrganizationUser,
  deleteCustomerOrganizationUser,
  inviteCustomerOrganizationUser,
  addFPsCustomerOrganizationUser,
  loadUsersInfoForStaffMember,
  transferUserFormOrgToAnother,
  notifySubscriptionExpiredCustomerOrganizationUser,
  updateCustomerOrganizationUser,
  loadCustomerOrganizationsListPage,
  setOrganizationActive,
  setOrganizationInactive,
} from './staff';
import { fileDownload, fileContentCopy, loadResultFile } from './download';
import {
  loadBulkDataFeedOptions,
  loadBulkDataFeeds,
  downloadBulkDataFeed,
} from './bulkdata';
import {
  loadDataMarketplaceCategories,
  loadDataMarketplaceFeeds,
  loadDataMarketplaceFeedOptions,
  downloadDataMarketplaceFeed,
} from './marketplace';

export function* sagas() {
  // VERSION
  yield takeEvery(types.VERSION, loadAPIVersion);

  // IOC
  yield takeLatest(types.UPDATE_IOC_LIST, updateIocList);
  yield takeLatest(types.UPDATE_IOC_LIST_FROM_CACHE, updateIocListFromCache);
  yield takeLatest(types.PAGINATION_IOC_LIST, paginationIocList);
  yield takeLatest(
    types.PAGINATION_IOC_LIST_FROM_CACHE,
    paginationIocListFromCache,
  );
  yield takeEvery(types.EXPORT_LIST_TO_CSV, exportListToCSV);
  yield takeEvery(types.EXPORT_LIST_TO_SPLUNK, exportListToSplunk);
  yield takeEvery(types.EXPORT_LIST_TO_STIX, exportListToSTIX);
  yield takeEvery(types.EXPORT_LIST_TO_STIX_LIMITED, exportListToSTIXLimited);
  yield takeEvery(types.EXPORT_LIST_TO_JSON, exportListToJSON);
  yield takeEvery(types.EXPORT_SINGLE_IOC, exportSingleIOC);
  yield takeEvery(types.EXPORT_EXPLORE_RESULT_TO_CSV, exportExploreResultToCSV);
  yield takeEvery(
    types.EXPORT_EXPLORE_RESULT_TO_JSON,
    exportExploreResultToJSON,
  );
  yield takeEvery(types.EXPORT_SPOOFING_TO_CSV, exportSpoofingToCSV);
  yield takeEvery(types.EXPORT_SPOOFING_TO_JSON, exportSpoofingToJSON);
  yield takeEvery(types.EXPORT_DANGLING_DNS_TO_CSV, exportDanglingDNSToCSV);
  yield takeEvery(types.EXPORT_DANGLING_DNS_TO_JSON, exportDanglingDNSToJSON);
  yield takeEvery(
    types.EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_CSV,
    exportHostingInfrasctructureASNsToCSV,
  );
  yield takeEvery(
    types.EXPORT_HOSTING_INFRASTRUCTURE_ASNS_TO_JSON,
    exportHostingInfrasctructureASNsToJSON,
  );
  yield takeEvery(
    types.EXPORT_SUBDOMAIN_FINDER_TO_CSV,
    exportSubdomainFinderToCSV,
  );
  yield takeEvery(
    types.EXPORT_SUBDOMAIN_FINDER_TO_JSON,
    exportSubdomainFinderToJSON,
  );
  yield takeEvery(types.EXPORT_SHADOW_IT_TO_CSV, exportShadowITtoCSV);
  yield takeEvery(types.EXPORT_SHADOW_IT_TO_JSON, exportShadowITtoJSON);
  yield takeEvery(types.CLEAR_SCORE_DETAILS, clearScoreDetails);
  yield takeEvery(types.LOAD_SCORE_DETAILS, loadScoreDetails);
  yield takeEvery(types.LOAD_NEW_SCORE_DETAILS, loadNewScoreDetails);
  yield takeLatest(
    types.LOAD_MERGE_API_ENRICHMENT_SCORE_DETAILS,
    loadMergeAPIEnrichment,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_NEW_ENRICHMENT_SCORE_DETAILS,
    loadMergeAPINewEnrichment,
  );
  yield takeLatest(types.LOAD_UTILS_PARSE_IOC, loadUtilsParseIOC);
  yield takeLatest(types.LOAD_DNS_RECORDS, loadDnsRecords);
  yield takeLatest(
    types.LOAD_A_RECORDS_DOMAIN_ENRICHMENT,
    loadARecordsDomainEnrichment,
  );
  yield takeLatest(
    types.LOAD_AAAA_RECORDS_DOMAIN_ENRICHMENT,
    loadAAAARecordsDomainEnrichment,
  );
  yield takeLatest(
    types.LOAD_CNAME_RECORDS_DOMAIN_ENRICHMENT,
    loadCNAMERecordsDomainEnrichment,
  );
  yield takeLatest(
    types.LOAD_MX_RECORDS_DOMAIN_ENRICHMENT,
    loadMXRecordsDomainEnrichment,
  );
  yield takeLatest(
    types.LOAD_NS_RECORDS_DOMAIN_ENRICHMENT,
    loadNSRecordsDomainEnrichment,
  );
  yield takeLatest(
    types.LOAD_SOA_RECORDS_DOMAIN_ENRICHMENT,
    loadSOARecordsDomainEnrichment,
  );
  yield takeLatest(
    types.LOAD_TXT_RECORDS_DOMAIN_ENRICHMENT,
    loadTXTRecordsDomainEnrichment,
  );
  yield takeLatest(types.LOAD_IP_DENSITY, loadIpDensity);
  yield takeLatest(types.LOAD_PTR_LOOKUP, loadPTRLookup);
  yield takeEvery(
    types.LOAD_MERGE_API_DOMAIN_SCORE_DETAILS,
    loadMergeAPIDomainDetails,
  );
  yield takeEvery(types.LOAD_MERGE_API_IP_SCORE_DETAILS, loadMergeAPIIPDetails);
  yield takeEvery(types.CLEAR_EXPLORE_SCORE_DETAILS, clearExploreDetails);
  yield takeEvery(
    types.LOAD_MERGE_API_EXPLORE_SCORE_DETAILS,
    loadMergeAPIExploreDetails,
  );
  yield takeEvery(
    types.LOAD_HOSTING_INFRASTRUCTURE_ASN_DATA,
    loadHostingInfrastructureASNData,
  );

  yield takeEvery(
    types.LOAD_DANGLING_DNS_RECORDS_COUNT_DATA,
    loadDanglingDNSRecordsCountData,
  );

  yield takeEvery(
    types.LOAD_DANGLING_DNS_PROTECTION_DATA,
    loadDanglingDNSProtectionData,
  );

  yield takeEvery(
    types.LOAD_MERGE_API_MERGE_SCORE_DETAILS,
    loadMergeAPIMergeDetails,
  );
  yield takeEvery(types.LOAD_NAME_SERVER_AUTOFILL, loadNameServerAutoFill);
  yield takeEvery(types.LOAD_ASN_AUTOFILL, loadASNAutoFill);
  yield takeEvery(
    types.POST_MERGE_API_EXPLORE_SCORE_DETAILS,
    postMergeAPIExploreDetails,
  );
  yield takeEvery(
    types.POST_MERGE_API_MERGE_SCORE_DETAILS,
    postMergeAPIMergeDetails,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_DOMAIN_INFRA_TAGS,
    loadMergeAPIDomainInfraTags,
  );
  yield takeEvery(types.LOAD_HISTORY_QUERIES, loadHistoryQueries);
  yield takeEvery(types.UPDATE_HISTORY_QUERY, updateHistoryQuery);
  yield takeEvery(types.ADD_NEW_HISTORY_QUERY, addNewHistoryQuery);
  yield takeEvery(types.LOAD_HISTORY_QUERY_RESULT, loadHistoryQueryResult);
  yield takeEvery(types.COPY_HISTORY_QUERY_RESULT, copyHistoryQueryResult);
  yield takeEvery(
    types.CLEAR_COPY_HISTORY_QUERY_RESULT,
    clearCopyHistoryQueryResult,
  );
  yield takeEvery(
    types.DOWNLOAD_HISTORY_QUERY_RESULT,
    downloadHistoryQueryResult,
  );

  yield takeEvery(types.LOAD_MONITORING_FILE, loadMonitoringFile);
  yield takeEvery(types.LOAD_MONITORING_JSON_FILE, loadMonitoringJSONFile);
  yield takeEvery(types.SAVE_MONITORING_QUERY, saveMonitoringQuery);
  yield takeEvery(types.LOAD_MONITORING_QUERIES, loadMonitoringQueries);
  yield takeEvery(types.DELETE_MONITORING_QUERY, deleteMonitoringQuery);
  yield takeEvery(
    types.CHANGE_SCOPE_MONITORING_QUERY,
    changeScopeMonitoringQuery,
  );
  yield takeEvery(types.RUN_MONITORING_QUERY, runMonitoringQuery);
  yield takeEvery(
    types.LOAD_MONITORING_QUERY_RESULTS_HISTORY,
    loadMonitoringQueryResultsHistory,
  );
  yield takeEvery(types.UPDATE_MONITORING_QUERY, updateMonitoringQuery);
  yield takeEvery(
    types.LOAD_MERGE_API_EXPLORE_RECIPES,
    loadMergeAPIExploreRecipes,
  );
  yield takeEvery(types.LOAD_ATTACK_SURFACE_MAPPING, loadAttackSurfaceMapping);
  yield takeEvery(
    types.LOAD_DIGITAL_THREAT_MANAGEMENT,
    loadDigitalThreatManagement,
  );
  yield takeEvery(
    types.LOAD_MERGE_API_EXPLORE_RECIPE,
    loadMergeAPIExploreRecipe,
  );
  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_FORWARD_A,
    saveMergeAPIExploreRecipeForwardA,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_FORWARD_A,
    updateMergeAPIExploreRecipeForwardA,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_FORWARD_A,
    deleteMergeAPIExploreRecipeForwardA,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_FORWARD_A,
    loadMergeAPIExploreRecipeForwardA,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_FORWARD_A,
    changeScopeMergeAPIExploreRecipeForwardA,
  );
  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
    saveMergeAPIExploreRecipeHostingInfraIPs,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
    updateMergeAPIExploreRecipeHostingInfraIPs,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
    deleteMergeAPIExploreRecipeHostingInfraIPs,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
    loadMergeAPIExploreRecipeHostingInfraIPs,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRA_IPS,
    changeScopeMergeAPIExploreRecipeHostingInfraIPs,
  );
  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    saveMergeAPIExploreRecipeNameServerChanges,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    updateMergeAPIExploreRecipeNameServerChanges,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    deleteMergeAPIExploreRecipeNameServerChanges,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    loadMergeAPIExploreRecipeNameServerChanges,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_SERVER_CHANGES,
    changeScopeMergeAPIExploreRecipeNameServerChanges,
  );
  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_TXT,
    saveMergeAPIExploreRecipeTXT,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_TXT,
    updateMergeAPIExploreRecipeTXT,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_TXT,
    deleteMergeAPIExploreRecipeTXT,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_TXT,
    loadMergeAPIExploreRecipeTXT,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_TXT,
    changeScopeMergeAPIExploreRecipeTXT,
  );
  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
    saveMergeAPIExploreRecipeIPDiversity,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
    deleteMergeAPIExploreRecipeIPDiversity,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
    updateMergeAPIExploreRecipeIPDiversity,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
    loadMergeAPIExploreRecipeIPDiversity,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_IP_DIVERSITY,
    changeScopeMergeAPIExploreRecipeIPDiversity,
  );
  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    saveMergeAPIExploreRecipeLatestDNSRecords,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    deleteMergeAPIExploreRecipeLatestDNSRecords,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    updateMergeAPIExploreRecipeLatestDNSRecords,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    loadMergeAPIExploreRecipeLatestDNSRecords,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_LATEST_DNS_RECORDS,
    changeScopeMergeAPIExploreRecipeLatestDNSRecords,
  );

  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    saveMergeAPIExploreRecipeHostingInfrastructureASNs,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    deleteMergeAPIExploreRecipeHostingInfrastructureASNs,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    updateMergeAPIExploreRecipeHostingInfrastructureASNs,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    loadMergeAPIExploreRecipeHostingInfrastructureASNs,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_HOSTING_INFRASTRUCTURE_ASNS,
    changeScopeMergeAPIExploreRecipeHostingInfrastructureASNs,
  );

  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    saveMergeAPIExploreRecipeDanglingDNSRecordsCount,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    deleteMergeAPIExploreRecipeDanglingDNSRecordsCount,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    updateMergeAPIExploreRecipeDanglingDNSRecordsCount,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    loadMergeAPIExploreRecipeDanglingDNSRecordsCount,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_RECORDS_COUNT,
    changeScopeMergeAPIExploreRecipeDanglingDNSRecordsCount,
  );

  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    saveMergeAPIExploreRecipeDanglingDNSProtection,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    deleteMergeAPIExploreRecipeDanglingDNSProtection,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    updateMergeAPIExploreRecipeDanglingDNSProtection,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    loadMergeAPIExploreRecipeDanglingDNSProtection,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DANGLING_DNS_PROTECTION,
    changeScopeMergeAPIExploreRecipeDanglingDNSProtection,
  );

  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
    saveMergeAPIExploreRecipeSubdomainFinder,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
    deleteMergeAPIExploreRecipeSubdomainFinder,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
    updateMergeAPIExploreRecipeSubdomainFinder,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
    loadMergeAPIExploreRecipeSubdomainFinder,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SUBDOMAIN_FINDER,
    changeScopeMergeAPIExploreRecipeSubdomainFinder,
  );

  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT,
    saveMergeAPIExploreRecipeShadowIT,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT,
    deleteMergeAPIExploreRecipeShadowIT,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT,
    updateMergeAPIExploreRecipeShadowIT,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_SHADOW_IT,
    loadMergeAPIExploreRecipeShadowIT,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SHADOW_IT,
    changeScopeMergeAPIExploreRecipeShadowIT,
  );

  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_REVERSE_A,
    saveMergeAPIExploreRecipeReverseA,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_REVERSE_A,
    loadMergeAPIExploreRecipeReverseA,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_REVERSE_A,
    deleteMergeAPIExploreRecipeReverseA,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_REVERSE_A,
    updateMergeAPIExploreRecipeReverseA,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_REVERSE_A,
    changeScopeMergeAPIExploreRecipeReverseA,
  );
  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
    saveMergeAPIExploreRecipeDomainsOnServer,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
    deleteMergeAPIExploreRecipeDomainsOnServer,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
    updateMergeAPIExploreRecipeDomainsOnServer,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
    loadMergeAPIExploreRecipeDomainsOnServer,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_DOMAINS_ON_SERVER,
    changeScopeMergeAPIExploreRecipeDomainsOnServer,
  );
  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_SPOOFING,
    saveMergeAPIExploreRecipeSpoofing,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_SPOOFING,
    deleteMergeAPIExploreRecipeSpoofing,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_SPOOFING,
    updateMergeAPIExploreRecipeSpoofing,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_SPOOFING,
    loadMergeAPIExploreRecipeSpoofing,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_SPOOFING,
    changeScopeMergeAPIExploreRecipeSpoofing,
  );

  yield takeLatest(
    types.SAVE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
    saveMergeAPIExploreRecipeNameInTXT,
  );
  yield takeLatest(
    types.DELETE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
    deleteMergeAPIExploreRecipeNameInTXT,
  );
  yield takeLatest(
    types.UPDATE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
    updateMergeAPIExploreRecipeNameInTXT,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
    loadMergeAPIExploreRecipeNameInTXT,
  );
  yield takeLatest(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_RECIPE_NAME_IN_TXT,
    changeScopeMergeAPIExploreRecipeNameInTXT,
  );
  yield takeLatest(types.QUERY_NAME_IN_TXT_RECIPE, queryNameInTXTRecipe);
  yield takeLatest(types.CLONE_RECIPE, cloneRecipe);

  yield takeEvery(
    types.LOAD_MERGE_API_EXPLORE_ANYIP_SCORE_DETAILS,
    loadMergeAPIExploreAnyIPDetails,
  );
  yield takeEvery(
    types.LOAD_MERGE_API_EXPLORE_IP_DENSITY_DETAILS,
    loadMergeAPIExploreIPDensityDetails,
  );
  yield takeEvery(types.LOAD_IOC_NOTES, loadIOCNotes);
  yield takeEvery(types.DELETE_IOC_NOTE, deleteIOCNote);
  yield takeEvery(types.CREATE_IOC_NOTE, createIOCNote);
  yield takeEvery(types.UPDATE_IOC_NOTE, updateIOCNote);
  yield takeEvery(
    types.LOAD_MERGE_API_EXPLORE_DENSITY_DETAILS,
    loadMergeAPIDensityDetails,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_WHOIS_DETAILS,
    loadMergeAPIWhoisDetails,
  );
  yield takeLatest(
    types.LOAD_MERGE_API_EXPLORE_WHOIS_FALLBACK_DETAILS,
    loadMergeAPIWhoisFallbackDetails,
  );
  yield takeEvery(
    types.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMAS,
    loadMergeAPIExploreQueryBuilderSchemas,
  );

  yield takeEvery(
    types.LOAD_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
    loadMergeAPIExploreQueryBuilderSchema,
  );
  yield takeEvery(
    types.SAVE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
    saveMergeAPIExploreQueryBuilderSchema,
  );
  yield takeEvery(
    types.DELETE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
    deleteMergeAPIExploreQueryBuilderSchema,
  );
  yield takeEvery(
    types.CHANGE_SCOPE_MERGE_API_EXPLORE_QUERY_BUILDER_SCHEMA,
    changeScopeMergeAPIExploreQueryBuilderSchema,
  );
  yield takeLatest(types.LOAD_MERGE_API_RISK_SCORES, loadMergeAPIRiskScores);
  yield takeLatest(types.LOAD_MERGE_API_ASN_DETAILS, loadMergeAPIASNDetails);
  yield takeEvery(types.TOGGLE_FALSE_POSITIVE, toggleFalsePositive);
  yield takeEvery(types.TOGGLE_TRUE_POSITIVE, toggleTruePositive);
  yield takeEvery(types.CREATE_IOC, createIOC);
  yield takeEvery(types.DELETE_IOC, deleteIOC);
  yield takeEvery(types.DELETE_IOC_FROM_COLLECTION, deleteIOCFromCollection);
  yield takeEvery(
    types.LOAD_IOCS_FROM_SPECIFIC_COLLECTION,
    loadIOCSFromSpecificCollection,
  );
  yield takeEvery(
    types.LOAD_IOCS_PAGE_FROM_SPECIFIC_COLLECTION,
    loadIOCSPageFromSpecificCollection,
  );
  yield takeEvery(
    types.LOAD_IOCS_FROM_SPECIFIC_SHARED_COLLECTION,
    loadIOCSFromSpecificSharedCollection,
  );
  yield takeEvery(types.SAVE_BREADCRUMBS, saveBreadCrumbs);
  yield takeEvery(
    types.LOAD_BRAND_IMPERSONATION_RECIPE_RESULTS,
    loadBrandImpersonationRecipeResults,
  );
  yield takeEvery(
    types.LOAD_HOSTING_INFRASTRUCTURE_ASNS_RECIPE_RESULTS,
    loadHostingInfrastructureASNsRecipeResults,
  );
  yield takeEvery(
    types.LOAD_DANGLING_DNS_DETECTION_RECIPE_RESULTS,
    loadDanglingDNSDetectionRecipeResults,
  );
  yield takeEvery(
    types.LOAD_HOSTING_INFRASTRUCTURE_IPS_RECIPE_RESULTS,
    loadHostingInfrastructureIPsRecipeResults,
  );
  yield takeEvery(
    types.LOAD_SHADOW_IT_RECIPE_RESULTS,
    loadShadowITRecipeResults,
  );
  yield takeEvery(
    types.LOAD_SUBDOMAIN_FINDER_RECIPE_RESULTS,
    loadSubdomainFinderRecipeResults,
  );
  // Auth
  yield takeEvery(types.LOGIN, login);
  yield takeEvery(types.IMPERSONATE, impersonate);
  yield takeEvery(types.REFRESH_TOKEN, refreshAccessToken);
  yield takeEvery(types.CHECK_TOKEN, checkToken);
  yield takeEvery(types.RESET_PASSWORD, resetPassword);
  yield takeEvery(types.CONFIRM_PASSWORD_RESET, confirmPasswordReset);
  yield takeEvery(types.ENABLE_2FA, enable2fa);
  yield takeEvery(types.LOGIN_WITH_2FA, loginWith2fa);
  yield takeEvery(types.LOAD_2FA_QR, load2faQR);
  yield takeEvery(types.REMOVE_2FA, remove2fa);
  yield takeEvery(types.REGISTER, register);
  yield takeEvery(types.VALIDATE_EMAIL_ON_REGISTER, validateEmailOnRegister);

  // Subscription
  yield takeEvery(types.CONFIRM_EXTEND_SUBSCRIPTION, confirmExtendSubscription);

  // User
  yield takeEvery(types.LOAD_USER_PREFERENCES, loadUserPreferences);
  yield takeEvery(
    types.SET_CUSTOM_IP_RANGE_INDICATOR,
    setCustomIPRangeIndicator,
  );
  yield takeEvery(types.SET_CUSTOM_GEO_IP, setCustomGeoIP);
  yield takeEvery(types.LOAD_CUSTOM_GEO_IP, loadCustomGeoIP);
  yield takeEvery(
    types.LOAD_CUSTOM_GEO_IP_ORGANISATION,
    loadCustomGeoIPOrganisation,
  );
  yield takeEvery(
    types.LOAD_CUSTOM_DOMAIN_INDICATORS,
    loadCustomDomainIndicators,
  );
  yield takeEvery(
    types.SET_CUSTOM_DOMAIN_INDICATORS,
    setCustomDomainIndicators,
  );
  yield takeEvery(
    types.DELETE_CUSTOM_DOMAIN_INDICATORS,
    deleteCustomDomainIndicators,
  );
  yield takeEvery(
    types.LOAD_CUSTOM_IP_RANGE_INDICATORS,
    loadCustomIPRangeIndicators,
  );
  yield takeEvery(
    types.SET_CUSTOM_IP_RANGE_INDICATORS,
    setCustomIPRangeIndicators,
  );
  yield takeEvery(
    types.UPDATE_CUSTOM_IP_RANGE_INDICATORS,
    updateCustomIPRangeIndicators,
  );
  yield takeEvery(
    types.DELETE_CUSTOM_IP_RANGE_INDICATORS,
    deleteCustomIPRangeIndicators,
  );
  yield takeEvery(types.UPDATE_USER_PREFERENCES, updateUserPreferences);
  yield takeEvery(types.INVITE_USER, inviteUser);
  yield takeEvery(types.LOAD_USER, loadUser);
  yield takeEvery(types.LOAD_ORGANIZATION, loadOrganization);
  yield takeEvery(types.CHANGE_PASSWORD, changePassword);
  yield takeEvery(types.UPDATE_USER_PROFILE, updateUserProfile);
  yield takeEvery(types.UPDATE_USER_ORGANIZATION, updateOrganization);
  yield takeEvery(types.UPLOAD_PHOTO, uploadPhoto);
  yield takeEvery(types.LOAD_USERS, loadUsers);
  yield takeEvery(types.LOAD_USERS_INFO, loadUsersInfo);
  yield takeEvery(types.CREATE_USER, createUser);
  yield takeEvery(types.DELETE_USER, deleteUser);
  yield takeEvery(types.UPDATE_USER, updateUser);

  // Filters
  yield takeEvery(types.LOAD_FILTERS, loadFilters);
  yield takeEvery(types.LOAD_SPECIFIC_FILTER, loadSpecificFilter);
  yield takeEvery(types.LOAD_TAG_OPTIONS, loadTagOptions);
  yield takeEvery(types.AUTO_COMPLETE_TAG_OPTIONS, autoCompleteTagOptions);
  yield takeEvery(types.LOAD_FILTER_PROFILES, loadFilterProfiles);
  yield takeEvery(types.SAVE_FILTER_PROFILE, saveFilterProfile);
  yield takeEvery(types.SAVE_FILTER_PROFILE_LOCALLY, saveFilterProfileLocally);
  yield takeEvery(types.UPDATE_FILTER_PROFILE, updateFilterProfile);
  yield takeEvery(types.CHANGE_FILTER_PROFILE_NAME, changeFilterProfileName);
  yield takeEvery(types.DELETE_FILTER_PROFILE, deleteFilterProfile);
  yield takeEvery(types.APPLY_FILTERS, applyFilters);

  // Source
  yield takeEvery(types.LOAD_SOURCES, loadSources);
  yield takeEvery(types.LOAD_SOURCE, loadSource);
  yield takeEvery(
    types.LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE,
    loadSourcesIocCountsAndIsActive,
  );
  yield takeEvery(types.LOAD_SOURCES_IOC_COUNTS, loadSourcesIocCounts);
  yield takeEvery(types.CREATE_EMPTY_SOURCE, createEmptySource);
  yield takeEvery(types.CREATE_URL_SOURCE, createURLSource);
  yield takeEvery(types.CREATE_FILE_SOURCE, createFileSource);
  yield takeEvery(types.DELETE_SOURCE, deleteSource);
  yield takeEvery(types.CHANGE_SOURCE_SCOPE, changeSourceScope);
  yield takeEvery(types.ACTIVATE_SOURCE, activateSource);
  yield takeEvery(types.UPDATE_SOURCE, updateSource);
  yield takeEvery(types.UPDATE_FILE_SOURCE, updateFileSource);
  yield takeEvery(types.ADD_IOC_JSON, addIOCJson);
  yield takeEvery(types.PUBLISH_SOURCE, publishSource);

  // Feed
  yield takeEvery(types.LOAD_GLOBAL_FEEDS, loadGlobalFeeds);
  yield takeEvery(types.LOAD_FEEDS_GLOBAL, loadFeedsGlobal);
  yield takeEvery(types.LOAD_NEW_FEEDS_GLOBAL, loadNewFeedsGlobal);
  yield takeEvery(types.LOAD_FEED_PERFORMANCE, loadFeedPerformance);
  yield takeEvery(types.CLEAR_SOURCES_REPORTS, clearSourcesReports);
  yield takeEvery(types.LOAD_SOURCES_REPORTS, loadSourcesReports);
  yield takeEvery(types.LOAD_SOURCE_REPORT, loadSourceReport);
  yield takeEvery(types.LOAD_ALL_FEEDS, loadAllFeeds);
  yield takeEvery(types.CONSUME_FEED_DATA, consumeFeedData);
  yield takeEvery(types.CONSUME_FILE_DATA, consumeFileData);
  yield takeEvery(types.CREATE_VIRTUAL_FEED, createVirtualFeed);
  yield takeEvery(types.UPDATE_VIRTUAL_FEED, updateVirtualFeed);
  yield takeEvery(types.CREATE_GLOBAL_FEED, createGlobalFeed);
  yield takeEvery(types.DELETE_GLOBAL_FEED, deleteGlobalFeed);
  yield takeEvery(types.VERIFY_FEED_AUTH, verifyAuth);
  yield takeEvery(types.UPDATE_GLOBAL_FEED, updateGlobalFeed);
  yield takeEvery(types.LOAD_FEEDS, loadFeeds);
  yield takeEvery(types.LOAD_NEW_FEEDS, loadNewFeeds);
  yield takeEvery(types.LOAD_COLLECTIONS, loadCollections);
  yield takeEvery(
    types.LOAD_ORGANIZATION_COLLECTIONS,
    loadOrganizationCollections,
  );
  yield takeEvery(types.LOAD_ORGANIZATION_FEEDS, loadOrganizationFeeds);
  yield takeEvery(types.LOAD_NEW_ORGANIZATION_FEEDS, loadNewOrganizationFeeds);
  yield takeEvery(types.LOAD_MY_COLLECTIONS, loadMyCollections);
  yield takeEvery(types.LOAD_MY_FEEDS, loadMyFeeds);
  yield takeEvery(types.LOAD_NEW_MY_FEEDS, loadNewMyFeeds);
  yield takeEvery(types.SAVE_EMPTY_COLLECTION, saveEmptyCollection);
  yield takeEvery(types.UPDATE_FEED, updateFeed);
  yield takeEvery(types.UPDATE_COLLECTION, updateCollection);
  yield takeEvery(types.CHANGE_SCOPE_COLLECTION, changeScopeCollection);
  yield takeEvery(types.PUBLISH_COLLECTION, publishCollection);
  yield takeEvery(types.SHARE_COLLECTION, shareCollection);
  yield takeEvery(types.CREATE_FEED, createFeed);
  yield takeEvery(types.DELETE_FEED, deleteFeed);
  yield takeEvery(types.DELETE_MY_FEED, deleteMyFeed);
  yield takeEvery(types.DELETE_ORGANIZATION_FEED, deleteOrganizationFeed);
  yield takeEvery(types.EXPORT_FEED, exportFeed);
  yield takeEvery(types.DELETE_COLLECTION, deleteCollection);
  yield takeEvery(types.LOAD_COLLECTION, loadCollection);
  yield takeEvery(types.ACTIVATE_COLLECTION, activateCollection);
  yield takeEvery(types.ACTIVATE_FEED, activateFeed);
  yield takeEvery(types.ACTIVATE_MY_FEED, activateMyFeed);
  yield takeEvery(types.ACTIVATE_ORGANIZATION_FEED, activateOrganizationFeed);
  yield takeEvery(types.UPLOAD_TO_COLLECTION, uploadToCollection);
  yield takeEvery(
    types.CREATE_COLLECTION_BY_FILE_UPLOAD,
    createCollectionByFileUpload,
  );
  yield takeEvery(
    types.CREATE_COLLECTION_BY_URL_UPLOAD,
    createCollectionByURLUpload,
  );
  yield takeEvery(types.LOAD_AVAILABLE_FEEDS, loadAvailableFeeds);
  yield takeEvery(types.LOAD_IP_EDITABLE_FEEDS, loadIPEditableFeeds);
  yield takeEvery(types.LOAD_DOMAIN_EDITABLE_FEEDS, loadDomainEditableFeeds);
  yield takeEvery(types.LOAD_URL_EDITABLE_FEEDS, loadURLEditableFeeds);

  //Integrations
  yield takeEvery(types.LOAD_SPLUNK, loadIntegrations);
  yield takeEvery(types.UPDATE_SPLUNK, updateIntegrations);
  yield takeEvery(types.SAVE_SPLUNK, saveIntegrations);
  yield takeEvery(types.DELETE_SPLUNK, deleteIntegrations);
  yield takeEvery(types.LOAD_SLACK, loadSlack);
  yield takeEvery(types.SAVE_SLACK, saveSlack);
  yield takeEvery(types.UPDATE_SLACK, updateSlack);
  yield takeEvery(types.DELETE_SLACK, deleteSlack);
  yield takeEvery(types.LOAD_M_TEAMS, loadMTeams);
  yield takeEvery(types.SAVE_M_TEAMS, saveMTeams);
  yield takeEvery(types.UPDATE_M_TEAMS, updateMTeams);
  yield takeEvery(types.DELETE_M_TEAMS, deleteMTeams);
  yield takeEvery(
    types.GET_ACCESS_TOKEN_BROWSERLING,
    getAccessTokenBrowserling,
  );

  // Tags
  yield takeEvery(types.SEARCH_FOR_TAGS, searchForTags);
  yield takeEvery(types.ADD_IOC_TAG, addIOCTag);
  yield takeEvery(types.REMOVE_IOC_TAG, removeIOCTag);
  yield takeEvery(types.DELETE_TAG, deleteTag);

  // Groups
  yield takeEvery(types.LOAD_GROUPS, loadGroups);
  yield takeEvery(types.CREATE_GROUP, createGroup);
  yield takeEvery(types.DELETE_GROUP, deleteGroup);
  yield takeEvery(types.UPDATE_GROUP, updateGroup);

  // Departments
  yield takeEvery(types.LOAD_DEPARTMENTS, loadDepartments);
  yield takeEvery(types.CREATE_DEPARTMENT, createDepartment);
  yield takeEvery(types.DELETE_DEPARTMENT, deleteDepartment);
  yield takeEvery(types.UPDATE_DEPARTMENT, updateDepartment);

  // APIAccess
  yield takeEvery(types.LOAD_API_ACCESS, loadAPIAccess);
  yield takeEvery(types.CREATE_API_ACCESS, createAPIAccess);
  yield takeEvery(types.DELETE_API_ACCESS, deleteAPIAccess);
  yield takeEvery(types.UPDATE_API_ACCESS, updateAPIAccess);

  // Permissions
  yield takeEvery(types.REQUEST_PERMISSION, requestPermission);
  yield takeEvery(types.LOAD_PERMISSIONS, loadPermissions);

  // Dashboards
  yield takeEvery(types.LOAD_DASHBOARDS, loadDashboards);
  yield takeEvery(types.LOAD_DASHBOARD_DETAILS, loadDashboardDetails);
  yield takeEvery(types.CREATE_DASHBOARD, createDashboard);
  yield takeEvery(types.UPDATE_DASHBOARD, updateDashboard);
  yield takeEvery(types.DELETE_DASHBOARD, deleteDashboard);
  yield takeEvery(types.LOAD_WIDGETS, loadWidgets);
  yield takeEvery(types.UPDATE_DASHBOARD_CELL, updateDashboardCell);

  // Widgets
  yield takeEvery(types.LOAD_MOST_WIDESPREAD_TAG, loadMostWidespreadTag);
  yield takeEvery(types.LOAD_TOP_TRENDING_TAGS, loadTopTrendingTags);
  yield takeEvery(types.LOAD_FP_AVG, loadFPAvg);

  //Playbooks
  yield takeEvery(types.LOAD_PLAYBOOKS, loadPlaybooks);
  yield takeEvery(types.LOAD_PLAYBOOKS_LOGS, loadPlaybooksLogs);
  yield takeEvery(types.UPDATE_PLAYBOOKS, updatePlaybooks);
  yield takeEvery(types.SAVE_PLAYBOOKS, savePlaybooks);
  yield takeEvery(types.DELETE_PLAYBOOKS, deletePlaybooks);
  yield takeEvery(types.RUN_PLAYBOOKS, runPlaybooks);

  //Staff
  yield takeEvery(
    types.LOAD_CUSTOMER_ORGANIZATIONS_LIST,
    loadCustomerOrganizationsList,
  );
  yield takeEvery(
    types.LOAD_CUSTOMER_ORGANIZATIONS_LIST_PAGE,
    loadCustomerOrganizationsListPage,
  );
  yield takeEvery(
    types.CREATE_CUSTOMER_ORGANIZATION,
    createCustomerOrganization,
  );
  yield takeEvery(
    types.UPDATE_CUSTOMER_ORGANIZATION,
    updateCustomerOrganization,
  );
  yield takeEvery(types.LOAD_MY_SUBSCRIPTION_PLAN, loadMySubscriptionPlan);
  yield takeEvery(types.LOAD_MY_SUBSCRIPTION_LIMIT, loadMySubscriptionLimit);
  yield takeEvery(
    types.LOAD_CUSTOMER_SUBSCRIPTION_PLAN,
    loadCustomerSubscriptionPlan,
  );
  yield takeEvery(
    types.CREATE_CUSTOMER_SUBSCRIPTION,
    createCustomerSubscription,
  );
  yield takeEvery(
    types.UPDATE_CUSTOMER_SUBSCRIPTION,
    updateCustomerSubscription,
  );
  yield takeEvery(
    types.RESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION,
    restrictSubscriptionCustomerOrganization,
  );
  yield takeEvery(
    types.UNRESTRICT_SUBSCRIPTION_CUSTOMER_ORGANIZATION,
    unrestrictSubscriptionCustomerOrganization,
  );
  yield takeEvery(
    types.NOTIFY_SUBSCRIPTION_RESTRICTED_CUSTOMER_ORGANIZATION,
    notifySubscriptionRestrictedCustomerOrganization,
  );
  yield takeEvery(types.LOAD_CUSTOMER_ORGANIZATION, loadCustomerOrganization);
  yield takeEvery(
    types.DELETE_CUSTOMER_ORGANIZATION,
    deleteCustomerOrganization,
  );
  yield takeEvery(
    types.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST,
    loadCustomerOrganizationUsersList,
  );
  yield takeEvery(
    types.LOAD_CUSTOMER_ORGANIZATION_USERS_LIST_PAGE,
    loadCustomerOrganizationUsersListPage,
  );
  yield takeEvery(
    types.CREATE_CUSTOMER_ORGANIZATION_USER,
    createCustomerOrganizationUser,
  );
  yield takeEvery(
    types.DELETE_CUSTOMER_ORGANIZATION_USER,
    deleteCustomerOrganizationUser,
  );
  yield takeEvery(
    types.INVITE_CUSTOMER_ORGANIZATION_USER,
    inviteCustomerOrganizationUser,
  );
  yield takeEvery(
    // add missing pre-defined filter profiles
    types.ADD_FPs_CUSTOMER_ORGANIZATION_USER,
    addFPsCustomerOrganizationUser,
  );
  yield takeEvery(
    types.LOAD_USERS_INFO_FOR_STAFF_MEMBER,
    loadUsersInfoForStaffMember,
  );
  yield takeEvery(
    types.TRANSTER_USER_FROM_ORG_TO_ANOTHER,
    transferUserFormOrgToAnother,
  );
  yield takeEvery(
    types.NOTIFY_SUBSCRIPTION_EXPIRED_COMMUNITY_CUSTOMER_ORGANIZATION_USER,
    notifySubscriptionExpiredCustomerOrganizationUser,
  );
  yield takeEvery(
    types.UPDATE_CUSTOMER_ORGANIZATION_USER,
    updateCustomerOrganizationUser,
  );
  yield takeEvery(types.SET_ORGANIZATION_ACTIVE, setOrganizationActive);
  yield takeEvery(types.SET_ORGANIZATION_INACTIVE, setOrganizationInactive);

  //Download
  yield takeEvery(types.FILE_DOWNLOAD, fileDownload);
  yield takeEvery(types.FILE_CONTENT_COPY, fileContentCopy);
  yield takeEvery(types.LOAD_RESULT_FILE, loadResultFile);

  //DeepScan
  yield takeEvery(types.GET_DEEP_SCAN_METADATA, getDeepScanMetadata);
  yield takeEvery(types.GET_DEEP_SCAN, getDeepScan);
  yield takeEvery(
    types.GET_RECENTLY_RAN_SPQL_QUERIES,
    getRecentlyRanSPQLQueries,
  );
  yield takeEvery(types.GET_QUERY_EXAMPLES, getQueryExamples);
  yield takeEvery(types.GET_SAVED_SPQL_QUERIES, getSavedSPQLQueries);
  yield takeEvery(types.CREATE_SPQL_QUERY, createSPQLQuery);
  yield takeEvery(types.UPDATE_SPQL_QUERY, updateSPQLQuery);
  yield takeEvery(types.DELETE_SPQL_QUERY, deleteSPQLQuery);

  //Bulk Data Feeds
  yield takeEvery(types.LOAD_BULK_DATA_FEEDS, loadBulkDataFeeds);
  yield takeEvery(types.LOAD_BULK_DATA_FEED_OPTIONS, loadBulkDataFeedOptions);
  yield takeEvery(types.DOWNLOAD_BULK_DATA_FEED, downloadBulkDataFeed);

  //Marketplace
  yield takeEvery(
    types.LOAD_DATA_MARKETPLACE_CATEGORIES,
    loadDataMarketplaceCategories,
  );
  yield takeEvery(types.LOAD_DATA_MARKETPLACE_FEEDS, loadDataMarketplaceFeeds);
  yield takeEvery(
    types.LOAD_DATA_MARKETPLACE_FEED_OPTIONS,
    loadDataMarketplaceFeedOptions,
  );
  yield takeEvery(
    types.DOWNLOAD_DATA_MARKETPLACE_FEED,
    downloadDataMarketplaceFeed,
  );

  //Blog
  yield takeEvery(types.LOAD_AMBER_REPORTS, loadAmberReports);
  yield takeEvery(types.LOAD_AMBER_REPORT, loadAmberReport);
  yield takeEvery(types.LOAD_AMBER_REPORT_COUNT, loadAmberReportCount);
  yield takeEvery(types.LOAD_AMBER_REPORT_FEEDS, loadAmberReportFeeds);
  yield takeEvery(types.LOAD_AMBER_REPORT_TAGS, loadAmberReportTags);
  yield takeEvery(types.FILTER_AMBER_REPORTS, filterAmberReports);
  yield takeEvery(types.SET_AMBER_REPORTS_AS_SEEN, setAmberReportsAsSeen);
  yield takeEvery(types.SET_AMBER_REPORT_UNSEEN, setAmberReportUnseen);
  yield takeEvery(
    types.CHECK_ENRICHMENT_FEED_HAS_BLOGS,
    checkEnrichmentFeedHasBlogs,
  );

  //Websocket
  yield takeEvery(types.SET_WEBSOCKET_CONNECTION, setWebsocketConnection);
  yield takeEvery(
    types.SET_WEBSOCKET_CONNECTION_STATUS,
    setWebsocketConnectionStatus,
  );
}

export default sagas;
